<template>
	<a :href="link" :class="{ button: button === 'true' || button  }"><i class="ion-paper-airplane icon" v-if="icon"></i><span>{{ linkText }}</span></a>
</template>

<script>
	export default {
		props: {
			text: {
				type: String
			},
			domain: {
				type: String,
				default: window.location.hostname
			},
			user: {
				type: String,
				default: 'info'
			},
			subject: {
				type: String
			},
			body: {
				type: String
			},
			icon: {
				type: Boolean,
				default: true
			},
			button: {
				default: false
			}
		},
		computed: {
			link() {
				var vars = [];
				if(this.subject) vars.push(`subject=${this.subject}`);
				if(this.body) vars.push(`body=${encodeURI(this.body)}`);
				return this.subject || this.body
					? `mailto:${this.email}?${vars.join('&')}`
					: `mailto:${this.email}`;
			},
			email() {
				return `${this.user}@${this.domain}`;
			},
			linkText() {
				return this.text ? this.text : this.email;
			}
		}
	}
</script>

<style lang="scss" scoped>

    @import "./../../sass/variables";
	
	.icon {
		margin-right: 5px;
	}

	.button {
		display: inline-block;
		position: relative;
		color: $light-blue;
		margin-right: 5px;
		padding: 3px 12px;
		margin-left: 5px;

		&:before,
		&:after {
			border-color: lighten(#000, 90%);
			transform: translate(0, 0);
			transition: all 200ms;
			border-style: solid;
			position: absolute;
			display: block;
			height: 12px;
			content: '';
			width: 12px;
			opacity: 1;
		}

		&:before {
			border-width: 4px 0 0 4px;
			left: 0;
			top: 0;
		}

		&:after {
			border-width: 0 4px 4px 0;
			left: initial;
			top: initial;
			bottom: 0;
			right: 0;
		}

		i, span {
			color: $light-blue;
		}

		&:hover {
			background-color: rgba($light-blue, 0.05);
			
			&:before,
			&:after {
				transform: translate(0, 0);
				border-color: $light-blue;
				transition: all 200ms;
			}

			&:before {
				left: -4px;
				top: -4px;
			}

			&:after {
				bottom: -4px;
				right: -4px;
			}
		}
	}

</style>